import { useBlocker } from "react-router-dom";
import { useEffect } from "react";
import { hasBreakingChanges } from "../../utils/breaking-changes";

export function BreakingChangesReloadGuard() {
  const blocker = useBlocker(() => hasBreakingChanges());

  useEffect(() => {
    if (blocker.state === "blocked" && blocker.location) {
      const { pathname, search, hash } = blocker.location;
      window.location.assign(`${pathname}${search}${hash}`);
    }
  }, [blocker.state, blocker.location]);

  return null;
}
